import { render, staticRenderFns } from "./EvolutionOrdersVaccinationPanel.vue?vue&type=template&id=20432620&scoped=true&"
import script from "./EvolutionOrdersVaccinationPanel.vue?vue&type=script&lang=js&"
export * from "./EvolutionOrdersVaccinationPanel.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionOrdersVaccinationPanel.vue?vue&type=style&index=0&id=20432620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20432620",
  null
  
)

export default component.exports